import { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { Spin } from "antd";
import { urls } from "routes/urls";
import { routes } from "routes";
import MainLayout from "./MainLayout";
import { PrivateRoute } from "../Auth/PrivateRoute";
import { PageNotFound } from "../NotFoundComponent/Page404";
import { Login } from "../Auth/Login/Login";

export const AppRouter = () => {
    return (
        <Switch>
            <Route path={urls.login()} component={Login} />
            <Route path='/'>
                <MainLayout>
                    <Suspense fallback={<Spin className='suspense-router-spin' />}>
                        <Switch>
                            {routes.map((route) => (
                                <PrivateRoute key={route.path} {...route} />
                            ))}
                            <Route path='*' component={PageNotFound} />
                        </Switch>
                    </Suspense>
                </MainLayout>
            </Route>
        </Switch>
    );
};
